import React from 'react'
import {
  PathwayDetailFieldsForManageFragment,
  usePathwayTopicsUpdateOrderMutation
} from './ManagePathwayPage.codegen'
import { useMutableArg } from 'front-end/src/app/hooks/useMutableArg'
import { SavingStatus } from 'front-end/src/pages/manage-pathway-page/ManagePathwayPage'

export const useReorderPathwayResources = (
  currentTopicVersions:
    | PathwayDetailFieldsForManageFragment['currentTopicVersions']
    | null,
  pathwayId: number,
  setSavingStatus: (status: SavingStatus) => void,
  refetchPathway: () => Promise<unknown>
) => {
  const [topics, setTopics] = useMutableArg(currentTopicVersions)
  const [rearrangePathway, { loading }] = usePathwayTopicsUpdateOrderMutation()

  const handleChangeOrder = React.useCallback(
    async ({
      newIndex,
      oldIndex
    }: {
      newIndex: number
      oldIndex: number
    }): Promise<void> => {
      if (newIndex === oldIndex || !topics) {
        return
      }
      const topicsCopy = [...topics]
      // optimistic UI, rearrange elements while request in progress
      topicsCopy.splice(newIndex, 0, topicsCopy.splice(oldIndex, 1)[0])
      setTopics(topicsCopy)

      setSavingStatus(SavingStatus.SAVING)
      try {
        await rearrangePathway({
          variables: {
            id: Number(pathwayId),
            topicIds: topicsCopy.map((t) => t.topic.id)
          }
        })
      } finally {
        setSavingStatus(SavingStatus.SAVED)
        await refetchPathway()
      }
    },
    [topics, refetchPathway, setSavingStatus, pathwayId]
  )

  return {
    topics,
    handleChangeOrder,
    loading
  }
}
